import { IndustryTemplate } from '@/components';
import { hvacContent } from '@/data/industries/hvac';

export function HVACPage() {
  return <IndustryTemplate content={hvacContent} />;
}
